import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { fetchUserInviteByRegistrationToken } from "@api";
import { UserInvite, UserInviteStatus } from "@types";

interface RegistrationInfoProps {
  token?: string | null;
}

const WrapperDiv = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--global-spacing-xl) 0;
  gap: var(--global-spacing-l);
  margin: auto;
  text-align: center;
  @media screen and (min-width: 900px) {
    padding-top: 280px;
  }
`;

const InfoDiv = styled.div`
  font-size: var(--global-font-size-m);
`;

export const RegistrationInfo: React.FC<RegistrationInfoProps> = ({
  token,
  children,
}) => {
  const [userInvite, setUserInvite] = useState<UserInvite>();
  const organization = userInvite?.organization;

  const VALID_USER_INVITE_STATUS = [
    UserInviteStatus.Invited,
    UserInviteStatus.Registering,
    UserInviteStatus.LoggedIn,
  ];

  useEffect(() => {
    if (token) {
      fetchUserInviteByRegistrationToken(token, true)
        .then((user_invite) => {
          setUserInvite(user_invite);
        })
        .catch(() => setUserInvite(undefined));
    }
  }, [token]);

  const isValidInvite = (): boolean => {
    if (!token || !userInvite) return false;
    if (!VALID_USER_INVITE_STATUS.includes(userInvite.status)) return false;
    return true;
  };

  return (
    <WrapperDiv>
      {isValidInvite() && organization ? (
        <>
          <InfoDiv>
            You've been invited to collaborate with {organization.name}!
          </InfoDiv>
          <InfoDiv>
            Sign in or sign up with{" "}
            <span style={{ fontFamily: "var(--global-font-family-monospace)" }}>
              {userInvite?.invited_email}
            </span>{" "}
            to accept their invite and manage and enforce your code standards
            together.
          </InfoDiv>
        </>
      ) : (
        <InfoDiv>
          Sign in or sign up to manage and enforce your code standards.
        </InfoDiv>
      )}
      {children}
    </WrapperDiv>
  );
};
